import React from 'react'
import { Paper, Container as MuiContainer } from '@mui/material';
interface DefaultContainerProps {
    style: {},
    children: React.ReactNode
}
function DefaultContainer({
    children,
    style = {}
}: DefaultContainerProps) {

    return <MuiContainer
        square
        disableGutters
        elevation={12}
        component={Paper} sx={{
            width: "1000px",
            height: "600px",
            ...style
        }}>
        {children}
    </MuiContainer>
};

export default DefaultContainer
